<template>
<div class="shopGroup form dialog-form">
    <el-dialog title="商品分组" :visible.sync="dialogVisible" @close="cancel">
        <div class="filters">
            <div class="search">
                <el-input placeholder="输入分组名称" v-model="param.name" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <div class="add"></div>
        </div>
        <el-table :data="tableData" style="width: 100%" @select="selected" ref="multipleTable" max-height="300">
            <el-table-column type="selection" width="30"></el-table-column>
            <el-table-column label="商品名称" prop="name"></el-table-column>
            <el-table-column label="商品数" prop="number"></el-table-column>
            <el-table-column label="创建时间" prop="datetime"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {findAllGoodsGroup, findGoodsGroupInfo} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'shopGroup',
    data() {
        return {
            param: {
                name: ''
            },
            page: {
                page: 0,
                pageSize: 10,
                pageCount: 0
            },
            dialogVisible: false,
            tableData: [],
            selectedResult: {
                innerid: '',
                name: ''
            },
            flag: true,
            scrollTop: 0 // 上一次滚动距离
        }
    },
    mounted() {
    },
    methods: {
        handleQuery() {
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        selected(selection, row) {
            this.$refs.multipleTable.clearSelection()
            this.$refs.multipleTable.toggleRowSelection(row)
            this.selectedResult = row
        },
        openDialog(selectedResult) {
            this.tableData = []
            this.selectedResult = selectedResult
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.name = ''
            this.page = {
                page: 0,
                pageSize: 6,
                pageCount: 0
            }
            this.dialogVisible = false
        },
        submit() {
            let params = {
                divisioninnerid: this.selectedResult.innerid,
                page: 1,
                pageSize: 10
            }
            findGoodsGroupInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.selectedResult.dataContent = []
                    data.data.content.forEach(obj => {
                        this.selectedResult.dataContent.push({
                            objectid: obj.kmcinnerid,
                            objectname: obj.kmcname,
                            kmctype: obj.kmctype,
                            viewcount: obj.viewcount,
                            uprice: obj.uprice,
                            saleprice: obj.saleprice,
                            furl: obj.logoPic.furl,
                            duration: obj.logoPic.duration,
                            desc: obj.desc
                        })
                    })
                    this.$emit('setShopGroup', this.selectedResult)
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            this.page.page++
            this.setLoading(true)
            findAllGoodsGroup({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = this.tableData.concat(data.data.content)
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.tableData.forEach(obj => {
                        if (obj.innerid === this.selectedResult.innerid) {
                            this.$nextTick(() => {
                                this.$refs.multipleTable.toggleRowSelection(obj)
                            })
                        }
                    })
                    this.setLoading(false)
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-table__body-wrapper').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.page.page < _this.page.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getList()
                                }
                            }
                        })
                    })
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopGroup {
    .el-dialog .el-button{
        margin-bottom: 0;
        margin-left: 30px;
    }
    .el-date-editor .el-range-separator,.filters .el-input__icon{
        line-height: 26px;
    }
    .el-table th>.cell:nth-child(1)>label{
        display: none;
    }
    .filters{
        @include flexBox(flex-start);
        .search{
            .el-input{
                width: 240px !important;
            }
        }
    }
}
</style>
